const parseHtmltoString = (value) => {
  const parser = new DOMParser();
  const parsedDocument = parser.parseFromString(value, 'text/html');
  const textContent = parsedDocument.body.textContent;
  const sanitizedText = preventEmoji(textContent);

  return sanitizedText;
};

function preventEmoji(str: string): string {
  let strCopy = str;
  const emojiKeycapRegex = /[\u0023-\u0039]\ufe0f?\u20e3/g;
  const emojiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|[\u2600-\u27BF]/g;
  //eslint-disable-next-line no-misleading-character-class
  const emojiComponentRegex = /[\uD83C\uDFFB\uD83C\uDFFC\uD83C\uDFFD\uD83C\uDFFE\uD83C\uDFFF]/g;

  if (emojiKeycapRegex.test(strCopy)) {
    strCopy = strCopy.replace(emojiKeycapRegex, '');
  }
  if (emojiRegex.test(strCopy)) {
    strCopy = strCopy.replace(emojiRegex, '');
  }
  if (emojiComponentRegex.test(strCopy)) {
    for (const emoji of strCopy.match(emojiComponentRegex) || []) {
      if (/[\d|*|#]/.test(emoji)) {
        continue;
      }
      strCopy = strCopy.replace(emoji, '');
    }
  }

  return strCopy;
}

export default parseHtmltoString;
